"use strict";function t(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var e=t(require("styled-components")).default.section`
    width: 100%;
    position: relative;
    max-width: 100vw;

    .carousel {
        picture.active,
        picture.next,
        picture.prev {
            ${({loaded:t})=>!t&&"animation-duration: 0s !important;"}
        }
        .navigation {
            z-index: 4;
            height: 70%;
            margin-top: 10%;
        }
    }

    &:hover {
        cursor: pointer;
        .carousel .navigation {
            .DXButton {
                transform: none;
                opacity: 1;
            }

            &:last-child {
                .DXButton {
                    transform: none;
                }
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
